import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, useMsal } from '@azure/msal-react';
import type { FC, ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { msalConfig } from './msalConfig';

const msalInstance = new PublicClientApplication(msalConfig);

const HandleRedirectPromise: FC = () => {
  const { instance } = useMsal();
  useEffect(() => {
    instance.handleRedirectPromise().catch(console.error);
  }, [instance]);
  return null;
};

type ExpertMsalRootProps = {
  children: ReactNode;
};

/**
 * Renders the app immediately (no block on MSAL init). MSAL APIs must only be
 * used after initialize() completes; we mount HandleRedirectPromise only once
 * init has resolved so handleRedirectPromise() is never called before init.
 */
export const ExpertMsalRoot: FC<ExpertMsalRootProps> = ({ children }) => {
  const [msalReady, setMsalReady] = useState(false);

  useEffect(() => {
    msalInstance
      .initialize()
      .then(() => setMsalReady(true))
      .catch(console.error);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      {msalReady ? <HandleRedirectPromise /> : null}
      {children}
    </MsalProvider>
  );
};
